import { useEffect, useState } from "react";
import { ILead } from "../../models/BaseModel";
import { useRef } from "react";
import { Dialog } from "primereact/dialog";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { format } from "date-fns";

interface Iprops {
    singleData: ILead,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    hasPermission: (pageName: string, featureName?: string) => boolean,
    reloadData: () => void,
}

export interface IEmptyDevice {
    macAddress: "",
    device_Name: null
};

const schema = yup.object({

});

export const AccessoriesTable = (props: Iprops) => {
    const toast = useRef(null);
    const dt = useRef<any>(null);

    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false, status: [] } as { data: ILead[], count: number, loading: boolean, status: { id: number, name: string, count: number }[] });
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    }); const onPage = (event: any) => {
    delete event.filters;
    delete event.multiSortMeta;
    setLazyParams(event);
};

const onSort = (event: any) => {
    delete event.filters;
    delete event.multiSortMeta;
    setLazyParams(event);
};

useEffect(() => {
    if (props.open) {
        loadTableData();
    }
}, [props.open, lazyParams]);


    const exportCSV = () => {
        dt.current.exportCSV();
    };
    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    const onHide = () => {
        props.hideDialog();
    }


    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true }));

        const queryString = new URLSearchParams({
            lazyParams: JSON.stringify(lazyParams)
        }).toString();

        const response = await Fetch(`Leads/getAttachAccessoriesById/${props.singleData.id}`, "GET", null, `lazyParams=${JSON.stringify(lazyParams)}`, props.toast);

        if (response) {
            const data: { data: ILead[], count: number } = await response.json();
            setTableData({ data: data.data, count: data.count, status: [], loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false }));
        }
    };



    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: 'uppercase', fontFamily: 'Rancho', letterSpacing: 1 }}>Accessories List</h4>
                </div>
            </div>

        </div>
    );



    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);



    return (
        <>
            {/* </> <Toast ref={toast} /> */}
            <Dialog visible={props.open} style={{ width: '60vw' }} header={` `} modal className="p-fluid" onHide={onHide}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={tableData.data} lazy dataKey="id"
                    paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                    totalRecords={tableData.count} onPage={onPage}
                    onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    header={header}
                    loading={tableData.loading}
                >
                    <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                    <Column field="accessoriesName" header="Accessories" />
                    <Column field="accessoriesDealPrice" header="Accessories Price" />
                    <Column field="macAddress" header="Mac Address" />
                    <Column field="createdByName" header="Created By" />
                    <Column field="createdAt" header="Created At" body={(rowData) => format(new Date(rowData.createdAt+"Z"), 'dd/MM/yyyy')} />
                </DataTable>
            </Dialog>

        </>
    );
};
